import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import _ from 'lodash'

export const INITIAL_STATE = Immutable({
  loading: false,
  adding: false,
  data: {},
  arranging: false,
})

const { Types, Creators } = createActions({
  fetchItemsByRestaurant: ['restaurantId'],
  fetchItemsByRestaurantSuccess: ['data'],
  fetchItemsByRestaurantError: ['error'],

  saveItem: ['storeId', 'itemId', 'data', 'callBack'],
  deleteItem: ['storeId', 'item'],

  setItem: ['storeId', 'itemId', 'data'],
  setItemAdding: ['val'],

  setArranging: ['val'],
  saveArrangement: ['storeId', 'data', 'callBack'],

  setImages: ['storeId', 'itemId', 'urls'],

  setItemOptions: ['storeId', 'itemId', 'options'],
})

export const fetchItemsByRestaurantReducer = state => state.set('loading', true)

export const fetchItemsByRestaurantSuccess = (state, { data }) =>
  state.set('data', { ...state.data, ...data }).set('loading', false)

export const fetchItemsByRestaurantError = (state, { error }) =>
  state.set('error', error).set('loading', false)

export const deleteItemReducer = (state, { storeId, item }) =>
  state.setIn(['data', storeId], _.omit(state.data[storeId], item.id))

export const setItemReducer = (state, { storeId, itemId, data }) =>
  state.setIn(
    ['data', storeId, itemId],
    state.data[storeId][itemId]
      ? {
          ...state.data[storeId][itemId],
          name: data.name,
          current_price: data.current_price,
          tag: data.tag,
          status: data.status,
          description: data.description,
          code: data.code,
        }
      : {
          name: data.name,
          current_price: data.current_price,
          tag: data.tag,
          status: data.status,
          description: data.description,
          code: data.code,
        }
  )

export const setImagesReducer = (state, { storeId, itemId, urls }) =>
  state.setIn(['data', storeId, itemId, 'images'], {
    image: urls[0],
    thumb: urls[1],
  })

export const setItemAddingReducer = (state, { val }) => state.set('adding', val)

export const setArrangingReducer = (state, { val }) => state.set('arranging', val)

export const setItemOptionsReducer = (state, { storeId, itemId, options }) =>
  state.setIn(['data', storeId, itemId, 'options'], options)


export const itemReducer = createReducer(INITIAL_STATE, {
  [Types.FETCH_ITEMS_BY_RESTAURANT]: fetchItemsByRestaurantReducer,
  [Types.FETCH_ITEMS_BY_RESTAURANT_SUCCESS]: fetchItemsByRestaurantSuccess,
  [Types.FETCH_ITEMS_BY_RESTAURANT_ERROR]: fetchItemsByRestaurantError,

  [Types.DELETE_ITEM]: deleteItemReducer,
  [Types.SET_ITEM]: setItemReducer,
  [Types.SET_ITEM_ADDING]: setItemAddingReducer,

  [Types.SET_ARRANGING]: setArrangingReducer,
  [Types.SET_IMAGES]: setImagesReducer,

  [Types.SET_ITEM_OPTIONS]: setItemOptionsReducer,
})

export const ItemTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/itemReducer.js